import script from "./GenerateAppraisalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateAppraisalPage.vue?vue&type=script&setup=true&lang=js"

import "./GenerateAppraisalPage.vue?vue&type=style&index=0&id=e4276814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4276814"]])

export default __exports__